// extracted by mini-css-extract-plugin
export default {"hideTooltip":"j--z","fadeIn":"k--z","delay":"l--z","recommendedSizeTooltip":"m--z"};